"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.driftCircularProgressClasses = exports.DriftCircularProgress = void 0;
const react_1 = __importDefault(require("react"));
const CircularProgress_1 = __importStar(require("@mui/material/CircularProgress"));
Object.defineProperty(exports, "driftCircularProgressClasses", { enumerable: true, get: function () { return CircularProgress_1.circularProgressClasses; } });
const material_1 = require("@mui/material");
const getIndicatorSize = (size) => {
    switch (size) {
        case 'small':
            return 16;
        case 'medium':
            return 24;
        case 'large':
            return 36;
        default:
            return 36;
    }
};
const DriftCircularProgress = ({ size = 'large', showLabel, value, variant = 'determinate', }) => {
    const shouldShowText = showLabel && value !== undefined && size === 'large' && variant === 'determinate';
    return (react_1.default.createElement(material_1.Box, { sx: { position: 'relative', display: 'inline-flex' } },
        react_1.default.createElement(CircularProgress_1.default, { color: "primary", variant: variant, size: getIndicatorSize(size), value: value, thickness: 5 }),
        shouldShowText && (react_1.default.createElement(material_1.Box, { sx: {
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                position: 'absolute',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            } },
            react_1.default.createElement(material_1.Typography, { variant: "caption", component: "div", sx: { color: 'text.secondary', fontSize: 12 } }, `${Math.round(value)}%`)))));
};
exports.DriftCircularProgress = DriftCircularProgress;
//# sourceMappingURL=DriftCircularProgress.js.map